module.exports = __webpack_public_path__ + "img/Record.064a0ff8.png";